import { CollectionViewer } from '@angular/cdk/collections';
import { AgrDataSource } from '@next/core-lib/table-v2';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

export class ObservableTableDataSource<T> extends AgrDataSource<T> {
  constructor(private readonly rows$: Observable<T[]>) {
    super();
  }

  connect(_: CollectionViewer): Observable<T[]> {
    return this.rows$.pipe(tap(() => this.loadingSubject.next(false)));
  }
}
